import React, { useState, useEffect, useContext } from "react";
import CreateWealth from "../../Components/Dashboard/CreateWealth";
import MakeInvestment from "../../Components/Dashboard/MakeInvestment";
import Start from "../../Components/Dashboard/Start";
import Topsec from "../../Components/Dashboard/Topsec";
import VirtualAccountCard from "../../Components/Dashboard/VirtualAccountCard";
import getServices from "../../Services/get-service";
import { UserContext } from "../../Context/UserContext";

function MainDashboaard() {
  const [kycData, setKycData] = useState(null);
  const { userDetails } = useContext(UserContext);
  const userName = userDetails?.firstName || "";

  useEffect(() => {
    getServices.getUserKycLevel()
      .then((res) => {
        if (res.data && res.data.statusCode === 200) {
          setKycData(res.data.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching KYC level", err);
      });
  }, []);

  const showKycBanner = kycData && kycData.kycPercentage < 100;

  return (
    <div className="space-y-4">
      {showKycBanner && (
        <div className="bg-[#FFF5F3] text-[#FF5833] p-4 rounded-lg text-center text-[14px] md:text-[16px] italic font-medium w-full max-w-3xl mx-auto">
          Hello {userName}. You have to complete your <span className="font-bold underline">KYC</span> Verification to be able to carry out any transaction
        </div>
      )}
      <Topsec />
      <div className="grid grid-cols-1 lg:grid-cols-10 gap-4 mt-2 w-[100%] ">
        <div className="lg:col-span-3 h-full">
          <VirtualAccountCard />
        </div>
        <div className="lg:col-span-7 h-full">
          <Start kycData={kycData} />
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <MakeInvestment />
        <CreateWealth />
      </div>
    </div>
  );
}

export default MainDashboaard;
